export default __webpack_public_path__ + "static/media/brabout.79de283c.jpg";